export const upsertSensorGroupMessages: Record<string, string> = {
	'sensorGroup/update/success': 'Sensor group updated successfully',
	'sensorGroup/create/success': 'Sensor group created successfully',
	'sensorGroup/create/error': 'Failed to create sensor group',
	'sensorGroup/upsert/error': 'Failed to create or update sensor group',
	'sensorGroup/update/error': 'Failed to update sensor group',
	'sensorGroup/create/duplicate':
		'Sensor group exists, please choose a new name',
	'sensorGroup/update/duplicate':
		'Sensor group exists, please choose a new name',
	'sensorGroup/getSensors/error': 'Failed to load sensors',
};
